const icon = require('vue-svgicon');
icon.register({
    'play-button': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<rect width="40" height="40" rx="20" _fill="#000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 15.3687C15.5 14.6713 16.2589 14.2389 16.8588 14.5944L24.6742 19.2257C25.2624 19.5743 25.2624 20.4257 24.6742 20.7743L16.8588 25.4056C16.2589 25.7611 15.5 25.3287 15.5 24.6313V15.3687Z" fill="#FFFFFF"/>`,
    },
});
